export default {
    state: {
        curTemplate: {}
    },
    mutations: {
        updateCurTemplate(state, curTemplate) {
            state.curTemplate = curTemplate
        },
    },
    getters: {

    },
    actions: {

    }
}


// WEBPACK FOOTER //
// ./src/pages/returnVisit/returnVisit.js